export default {
    path: '/message',
    redirect: { name: 'notice' },
    component: () => import('@/pages/s'),
    children: [
        //新闻
        {
            path: 'news',
            name: 'news',
            component: () => import('@/pages/information/news'),
           
        },
        //公告
        {
            path: 'notice',
            name: 'notice',
            component: () => import('@/pages/information/notice'),
        },
        //新闻详情
        {
            path: 'newsDetail',
            name: 'newsDetail',
            component: () => import('@/pages/information/newsDetail'),
        },
        //公告详情
        {
            path: 'noticeDetail',
            name: 'noticeDetail',
            component: () => import('@/pages/information/noticeDetail'),
        },
        //通知列表
        {
            path: 'noticeList',
            name: 'noticeList',
            component: () => import('@/pages/information/noticeList'),
        }
    ]
}

